import { IAppState } from '../../../../../AppModulesWrapper';
import { EPaymentType, IPayment } from '../types';

export function selectPackagePayment(state: IAppState): IPayment | null {
  return state.servicePickerWidgetV2.paymentProcessing[EPaymentType.Package] || null;
}
